// eslint-disable-next-line no-unused-vars
import React from 'react';
import { Route, IndexRoute } from '@americanexpress/one-app-router'; // eslint-disable-line no-unused-vars
import Home from './Home/Home';
import MyActions from './MyActions/MyActions';
import ManageDigitalAssets from './ManageDigitalAssets/ManageDigitalAssets';
import ManageContacts from './ManageContacts/ManageContacts';
import ContactInformation from './ManageContacts/ContactInformation/ContactInformation';
import UserAccount from './UserAccount/UserAccount';
import ManageFxAccount from './ManageDigitalAssets/ManageFxAccount/ManageFxAccount';
import { routes } from '../constants/paths';
import Register from './Register/Register';

const childRoutes = () => [
  <Route path="/" key="fxg-portal">
    <IndexRoute component={Home} />
    <Route path={routes.home} component={Home} />
    <Route path={routes.myActions} component={MyActions} />
    <Route path={routes.manageDigitalAssets} component={ManageDigitalAssets} />
    <Route path={routes.manageDigitalAssetsFxAccount} component={ManageFxAccount} />
    <Route path={routes.manageContacts} component={ManageContacts} />
    <Route path={routes.manageContactsContactInfo} component={ContactInformation} />
    <Route path={routes.userDetails} component={UserAccount} />
    <Route path={routes.register} component={Register} />
  </Route>,
];
export default childRoutes;
